import { useI18n } from '../i18n/useI18n'

/**
 * Bascule francais / anglais en un seul appui. Les deux etiquettes sont
 * toujours visibles, pour que personne n'ait a deviner sur quoi appuyer.
 */
export function LanguageToggle() {
  const { lang, setLang } = useI18n()

  return (
    <div className="langtoggle" role="group" aria-label="Langue / Language">
      <button
        type="button"
        className={`langtoggle__btn ${lang === 'fr' ? 'is-active' : ''}`}
        aria-pressed={lang === 'fr'}
        onClick={() => setLang('fr')}
      >
        FR
      </button>
      <button
        type="button"
        className={`langtoggle__btn ${lang === 'en' ? 'is-active' : ''}`}
        aria-pressed={lang === 'en'}
        onClick={() => setLang('en')}
      >
        EN
      </button>
    </div>
  )
}
